<template>
  <popup
    class="rb-popup-share"
    title="Share"
    :active="active"
    :on-screen="onScreen"
    @close="close"
  >
    <div class="rb-center">
      <p>There's no OUI without U and I! Share the love!</p>
      <div class="rb-social-share">
        <div class="rb-share-item">
          <a
            target="_blank"
            :href="`https://twitter.com/share?url=${urlShare}`"
            aria-label="Share this product on Twitter"
            >Twitter</a
          >
          <div class="rb-share-icon"><icon-twitter /></div>
        </div>
        <div class="rb-share-item">
          <a
            target="_blank"
            :href="`https://www.facebook.com/sharer/sharer.php?u=${urlShare}`"
            aria-label="Share this product on Facebook"
            >Facebook</a
          >
          <div class="rb-share-icon"><icon-facebook /></div>
        </div>
        <div class="rb-share-item">
          <a
            target="_blank"
            href="//pinterest.com/pin/create/button/?url=${urlShare}&media=${urlProductImage}&description=${productTitle}`"
            aria-label="Share this product on Pinterest"
            >Pinterest</a
          >
          <div class="rb-share-icon"><icon-pinterest /></div>
        </div>
        <div class="rb-share-item">
          <a
            target="_blank"
            :href="`mailto:?subject= I want to share this with you &amp;body= Hi there, Check out this product in our store ${urlShare}!`"
            aria-label="Share this product via Email"
            >Email</a
          >
          <div class="rb-share-icon"><icon-envelope /></div>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
/**
 * Popup with social share links
 *
 * @implements
 * PopupMixin
 *
 * @props
 * data: Object
 *
 */
import Popup from "@/components/Popup";
import PopupMixin from "@/mixins/PopupMixin";
import IconTwitter from "@/components/icons/IconTwitter";
import IconFacebook from "@/components/icons/IconFacebook";
import IconPinterest from "@/components/icons/IconPinterest";
import IconEnvelope from "@/components/icons/IconEnvelope";
export default {
  components: {
    Popup,
    IconTwitter,
    IconFacebook,
    IconPinterest,
    IconEnvelope,
  },
  mixins: [PopupMixin],
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    urlShare: function () {
      if (!this.data) return "";
      return this.data.urlShop + this.data.urlProduct;
    },
    urlProductImage: function () {
      // pass featured_media product.featured_image | image_url
      return "";
    },
    productTitle: function () {
      // pass product title encoded
      return "";
    },
  },
};
</script>
